import React from 'react'
import AccordionList from '@embracesbs/component-accordionlist/AccordionList'
import Accordion from '@embracesbs/component-accordion/Accordion'
import Divider from '@embracesbs/component-divider'
import CMSAccordionContent from './CMSAccordionContent'
import Maintenance from './Maintenance'
import NotificationsList from './NotificationsList'
import SNSAccordionContent from './SNSAccordionContent'
import TenantCertificates from './TenantCertificates'

interface TenantRuntimeSettingsPropss {}

const TenantRuntimeSettings: React.FC<TenantRuntimeSettingsPropss> = () => {
  return (
    <AccordionList>
      <Accordion key='Maintenance' id='Maintenance' headerTitle='Maintenance'>
        <Maintenance />
      </Accordion>
      <Divider />
      <Accordion key='Notifications' id='Notifications' headerTitle='Notifications'>
        <NotificationsList />
      </Accordion>
      <Divider />
      <Accordion key='CMS' id='CMS' headerTitle='CMS'>
        <CMSAccordionContent />
      </Accordion>
      <Divider />
      <Accordion key='SharedNotificationService' id='SharedNotificationService' headerTitle='Shared Notification Service'>
        <SNSAccordionContent />
      </Accordion>
      <Divider />
      <Accordion key='Certificates' id='Certificates' headerTitle='Certificates'>
        <TenantCertificates />
      </Accordion>
      <Divider />
    </AccordionList>
  )
}

export default TenantRuntimeSettings
